<template>
  <component
    :is="config.isScroll ? ElScrollbar : 'div'"
    :class="{ 'new-detail-item': true }"
    :style="{
        height: typeof config.height == 'number' ? config.height + 'px' : 'auto',
      }"
  >
    <h6 class="new-detail-item-title">{{ page.title }}</h6>
    <div
      class="new-detail-item-info"
    >{{ $t('texts.createTime') }}: {{ page.onlineTime }} {{ $t('texts.readAmount') }}: {{ page.readNum }}</div>
    <div class="new-detail-item-cont" v-html="page.content"></div>
    <div class="new-detail-item-btn" v-if="config.isShowBackBtn">
      <el-button size="small" @click="getBack">{{ $t('texts.backPrevPage')  }}</el-button>
    </div>
  </component>
</template>
  
<script setup>
import { ref, computed, onMounted, inject } from "vue";
import { useRoute, useState, useAsyncData } from "#app"; // Nuxt 3 相关 hook
import { getActiveListFormPlatform } from "@/api";
import { ElButton ,ElScrollbar } from "element-plus";
import useLocate from "./uses/useLocate.js";
 

// 提供组合式 API 的 props
const props = defineProps({
  allArcListMap: {
    type: Object,
    default: () => ({})
  },
  currentElementIndex: {
    type: Array,
    default: () => []
  },
  idx: {
    type: Number,
    default: -1
  },
  parentKeys: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: true
  },
  config: {
    type: Object
  }
});

// 响应式数据
const page = ref({});

let { langJson, nowLocale, getLocaleText } = useLocate();
// 获取页面数据

const route = useRoute();
let detailId = getRouteId();

function getRouteId() {
  return props.config.isGetRouteId
    ? (route.query && route.query.detailId) || ""
    : props.config.value;
}
const getPageData = inject("detailData_" + detailId);
let pageData=null;
if(getPageData){
    pageData=getPageData();
}
console.log("pageData",pageData)
if (pageData && pageData.title) {
  page.value = pageData;
}
onMounted(async () => {
  detailId = getRouteId();
  if (!page.value || !page.value.title) {
    const resAll = await getActiveListFormPlatform({
      id: detailId,
      categoryId:
        props.config.isGetRouteId || props.config.value
          ? undefined
          : props.config.categoryId,
      topicId:
        props.config.isGetRouteId || props.config.value
          ? undefined
          : props.config.themeId,
      pageNo: 0,
      pageSize: 1
    });
    const res = resAll.data;
    if (res && res.dataList && res.dataList[0]) {
      page.value = res.dataList[0];
    }
  }
});

// 计算属性
const currentElementIndexStr = computed(() => {
  return props.currentElementIndex.length
    ? props.currentElementIndex.join("x")
    : "";
});

// 方法
const getBack = () => {
  history.go(-1);
};
</script>
  
<style scoped>
.new-detail-item {
  padding: 10px;
}

.new-detail-item .new-detail-item-title {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.new-detail-item .new-detail-item-info {
  font-size: 12px;
  padding: 10px 0;
  color: #999;
}

.new-detail-item .new-detail-item-cont {
  font-size: 14px;
  padding: 10px 0 10px;
}

.new-detail-item .new-detail-item-cont :deep(img)  {
  display: block;
  max-width: 100%;
}

.new-detail-item .new-detail-item-btn {
  padding: 10px 0;
  text-align: center;
}
</style>
  